<!--<template>-->
<!--<div>-->
<!--&lt;!&ndash;  开票 makeInvoice&ndash;&gt;-->
<!--&lt;!&ndash;  开票记录 invoiceRecord&ndash;&gt;-->
<!--  开票管理-->
<!--  <button @click="jump">开票记录</button>-->
<!--  <button @click="jump1">开票</button>-->
<!--  <div>-->
<!--&lt;!&ndash;    <input v-for="(i,index) in 4" type="checkbox" :name="index" v-model="hobby" :value="i">&ndash;&gt;-->
<!--  </div>-->
<!--   <div id="vm">-->
<!--  <div>请选择你的爱好(vue)</div>-->
<!--  <div v-for="(item,k) in datas">-->
<!--   <input type="checkbox" v-model="hobby2"  :name="item.name" :value="item.name" >游泳+{{k}}-->
<!--   </div>-->
<!--   <div>你已选中：{{hobby2}}</div>-->
<!--  </div>-->
<!--</div>-->

<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "Index",-->
<!--  data(){-->
<!--    return {-->
<!--    }-->
<!--  },-->
<!--  // watch:{-->
<!--  //   hobby:-->
<!--  // },-->
<!--  methods:{-->
<!--    // jump(){-->
<!--    //   this.$router.push('/Financial/InvoiceManage/InvoiceRecords')-->
<!--    // },-->
<!--    // jump1(){-->
<!--    //   this.$router.push('/Financial/InvoiceManage/Detail')-->
<!--    // }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<!--<template>-->
<!--<div>分销商对账管理-->
<!--  <button @click="jump">详情</button>-->
<!--</div>-->

<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "Index",-->
<!--  methods:{-->
<!--    jump(){-->
<!--      this.$router.push('/Financial/DealerFinancialManage/Detail')-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<template>
  <div class="page" v-loading="loading">
    <!--    导出  Export    导入物流信息 importLogisticsInfo-->
    <!--    订单详情   orderDetail-->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="分销商名称:">
              <el-input v-model="searchData.Name" placeholder="请输入分销商名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <div class="flex">
                <el-button type="primary" @click="searchFun">查询</el-button>
                <el-button @click="resetFun">重置</el-button>
                <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-form-item label="对账周期：">-->
        <!--          <el-date-picker-->
        <!--              v-model="valueTime"-->
        <!--              type="datetimerange"-->
        <!--              value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--              range-separator="至"-->
        <!--              start-placeholder="开始日期"-->
        <!--              end-placeholder="结束日期"-->
        <!--              @change="handlePicker"-->
        <!--          ></el-date-picker>-->
        <!--        </el-form-item>-->

      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row v-loading="listLoading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="name" label="分销商名称" width="100" align="center"></el-table-column>
      <el-table-column prop="orderNo" label="开票信息" width="320">
        <template slot-scope="scope">
          <div>
            <p>发票类型:{{ scope.row.invoiceType }}</p>
            <p>抬头:{{ scope.row.invoiceRise }}</p>
            <p>纳税人识别号:{{ scope.row.taxpayerNumber }}</p>
            <p>地址:{{ scope.row.invoiceAddress }}</p>
            <p>开户行:{{ scope.row.invoiceBank }}</p>
            <p>银行账户:{{ scope.row.invoiceBankAccount }}</p>
            <p>电话:{{ scope.row.invoiceMobile }}</p>
          </div>

        </template>
      </el-table-column>
      <el-table-column label="状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.stayBillingNumber === 0 ? '已完成' : '可开票' }}
          </el-tag>

        </template>
      </el-table-column>
      <el-table-column prop="completeOrderNumber" label="订单数量" align="center"></el-table-column>
      <!--        <el-table-column prop="supplierName" label="订单来源" width="120" align="center"></el-table-column>-->
      <el-table-column prop="completeOrderAmount" label="金额合计" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].Name-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="stayBillingNumber" label="未开票订单数" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span-->
        <!--                            style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="stayBillingAmount" label="未开票金额" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName }}-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="billingNumber" label="已开票订单数" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].unitPrice-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="billingAmount" label="已开票金额" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>

    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload, GetBillingOrderList,
  GetBillingAll
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        Name: null,
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      loading: false
    };
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableList();
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      console.log('this.buttonList_toolBar', this.buttonList_toolBar);
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log('this. this.buttonList_table', this.buttonList_table);
    }
  },
  methods: {
    invoiceRecord(button, index, row) {
      // console.log('开票记录',`/Financial/InvoiceManage/InvoiceRecords?row=${row.id}`);
      this.$router.push(`/Financial/InvoiceManage/InvoiceRecords?`)
    },
    // 开票
    makeInvoice(button, index, row) {
      console.log('开票', row);
      let rowData = JSON.stringify(row)
      this.$router.push(`/Financial/InvoiceManage/Detail?row=${rowData}`)
    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await GetBillingAll(this.searchData);
      console.log('list', res);
      setTimeout(() => {
        this.loading = false;
      }, 500)
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.msg)
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.beginCreateTime = null
        this.searchData.endCreateTime = null
      } else {
        this.searchData.beginCreateTime = date[0]
        this.searchData.endCreateTime = date[1]
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        Name: '',
      };
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

